import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import PayList from './components/PayList';

const { Cell } = ResponsiveGrid;

const Pay = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="繳費列表"
        // description="管理費"
        breadcrumbs={[
          {
            name: '繳費系統',
          },
          {
            name: '繳費列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <PayList />
    </Cell>
  </ResponsiveGrid>
);

export default Pay;
